import React from 'react';

function Banner() {
    return null; // Component disabled - no rendering
}

export default Banner